import { BaseEntity } from "BaseEntity"

export class UserPermissionDTO extends BaseEntity {
	protected readonly businessObject: BaseEntity	
	protected readonly objectId: string
	protected readonly objectName: string
	protected readonly plantName: string
	protected readonly plantId: string
	protected readonly plantCode: string
	protected readonly sectorName: string
	protected readonly canCreate: bool
	protected readonly canDelete: bool
	protected readonly canRead: bool
	protected readonly canUpdate: bool
	protected readonly canRun: bool

	
}
